import { FormattedMessage } from 'react-intl';
import { Content } from '../components/Content';
import { Button } from '../components/Button';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { Description } from '../components/Description';
import { PageTitle } from '../components/PageTitle';

export const Home = () => {
  const navigate = useNavigate();

  const click = useCallback(() => {
    navigate('/draft/create');
  }, [navigate]);

  return (
    <Content>
      <PageTitle>
        <FormattedMessage id="homeTitle" />
      </PageTitle>
      <Description>
        <FormattedMessage id="homeDescription" />
      </Description>
      <Button color={'yellow'} onClick={click}>
        <FormattedMessage id="create" />
      </Button>
    </Content>
  );
};
